import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import PropTypes from "prop-types";

import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../Components/adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import ToolTip from "../ToolTip";

import {BUTTON_COLORS, BUTTON_TYPES} from "./constants";

const FunctionButton = ({
  name,
  className = "",
  color = BUTTON_COLORS.BLUE,
  type = BUTTON_TYPES.BUTTON,
  autoWidth,
  autowidth,
  onClick = () => {},
  tooltipMessage = "",
  width = null,
  style,
  disabled,
  readOnly,
  children = null,
  noFunctional = false,
  bottomTooltip = false,
  hidden = false,
  dataProp,
  sign = false,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
}) => {
  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  const buttonClassName = `fixed_button fixed_button__${color} ${
    !disabled && !readOnly && !noFunctional && !isDisabledByRoutePermission && !hidden ? "btn-responsive" : ""
  } ${className} ${autoWidth || autowidth ? "autoWidth" : ""} ${noFunctional ? "noFunctional" : ""}
  ${hidden ? "hiddenEl" : ""} 
  `;

  const {t} = useTranslation();
  const tooltipTitle = typeof tooltipMessage === "string" ? t(tooltipMessage) : tooltipMessage;

  return (
    <button
      className={buttonClassName}
      onClick={onClick}
      disabled={isDisabledByRoutePermission || disabled || noFunctional || readOnly}
      type={type}
      style={width ? {width: width, ...style} : {...style}}
      data-prop={dataProp}
    >
      <ToolTip
        title={
          noFunctional
            ? t("No functional")
            : isDisabledByRoutePermission
            ? "Your position has no permission for this action"
            : tooltipTitle
        }
        bottom={bottomTooltip}
      >
        <div className="center">
          {children}
          {typeof name === "string" ? t(name) : name}
          {sign && (
            <div
              className={clsx(
                "btnSign",
                (disabled || readOnly || noFunctional || isDisabledByRoutePermission) && "blur",
              )}
            >
              {t(sign)}
            </div>
          )}
        </div>
      </ToolTip>
    </button>
  );
};

FunctionButton.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.values(BUTTON_COLORS)),
  type: PropTypes.oneOf(Object.values(BUTTON_TYPES)),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  sign: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default FunctionButton;
